import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/reports/jobProgressReport'
import Component from 'components/Reports/JobProgressReport'

export default createListViewContainer({ actions, selectors: selectors.jobProgressReport })(Component)
